import React from 'react';
import './Hero.css';
import illustration from '../../assets/illustration-1.svg';


function Hero() {
    return (
        <header className='hero-content'>
            <div className='hero-details'>
                <h1>All your files in one secure location, accessible anywhere.</h1>
                <p>
                    Fylo stores your most important files in one secure location. Access
                    them wherever you need, share and collaborate with friends, family, and co-workers.
                </p>
                <div className='hero-input'>
                    <input type="text" placeholder="Enter your email.." />
                    <button>Get Started</button>
                </div>
            </div>
            <div className='hero-img'>
                <img src={illustration} alt="hero"/>
            </div>
        </header>
    );
}

export default Hero
